import { useQuery } from '@hooks/reactQuery';

import { getPresets } from '@api/configurationComparison';

import { extractQueryParams } from '@utils/common';
import { preparePresetsTreeOptions } from '@utils/treeFormatter/treeFormatter';

import { TCMSitesIdsDTO } from '@interfaces/cmModule/dto/cmModuleDTO';
import { IListOfTreePresets } from '@interfaces/components/tree';

import { refetchOptions } from '@constants/common';
import { PRESET_TREE } from '@constants/queryKeys';

export const useQueryPresets = ({
	nodeType,
	technology,
	vendor,
}: TCMSitesIdsDTO) => {
	const { data: presetsTreeOptions } = useQuery({
		queryKey: [PRESET_TREE, { nodeType, technology, vendor }],
		queryFn: extractQueryParams(getPresets),
		enabled: [!!nodeType, !!technology, !!vendor],
		select: (options: Array<IListOfTreePresets>) => preparePresetsTreeOptions(options),
		...refetchOptions,
	});

	return { presetsTreeOptions };
};
